module.exports = __webpack_public_path__ + "img/shape-metal_ay_hover@2x.8a98ea7b.png";